module.exports = __webpack_public_path__ + "static/media/ic_hearing_set_active.4d9766c7.svg";